module.exports = __webpack_public_path__ + "img/17-4.b0e6a77d.jpg";